import React from "react";

const PaymentCard = ({ title, amount }) => {
  return (
    <div className="col-2">
      <div className="info-box bg-gray">
        <span className="info-box-icon">
          <i className="fas fa-sack-dollar"></i>
        </span>
        <div className="info-box-content">
          <span className="info-box-text">{title}</span>
          <span className="info-box-number">{amount}</span>
          <div className="progress">
            <div className="progress-bar" style={{ width: "100%" }} />
          </div>
          <span className="progress-description"></span>
        </div>
      </div>
    </div>
  );
};

const CardPayementTickets = ({
  espece,
  cheque,
  virement,
  carteCadeau,
  card,
}) => {
  return (
    <section className="content mt-2">
      <div className="container-fluid">
        {/* <div class="card card-gray">
          <div class="card-body">
            <b>Détails des paiements</b>
            <hr /> */}
        <div className="row" style={{ justifyContent: "center" }}>
          {/* <div className="row"> */}
          <PaymentCard title="Espèce" amount={espece} />
          <PaymentCard title="TPE" amount={card} />
          <PaymentCard title="Chèque" amount={cheque} />
          <PaymentCard title="Virement" amount={virement} />
          <PaymentCard title="Carte Cadeau" amount={carteCadeau} />
        </div>
      </div>
      {/* </div>
      </div> */}
    </section>
  );
};

export default CardPayementTickets;
